import { IOGImage } from '@lemon8/web-app-shared/ssr';
import { useAtomValue } from 'jotai';
import { $CurrentAvailableExperienceDataOrNull } from '../atoms';
import { loadable } from 'jotai/utils';

export const useExperienceCover: () => IOGImage | null = () => {
  const loadableCurrentAnswer = useAtomValue(loadable($CurrentAvailableExperienceDataOrNull));

  if (loadableCurrentAnswer.state !== 'hasData') {
    return null;
  }

  const data = loadableCurrentAnswer.data;

  if (!data) {
    return null;
  }
  const { articleInfoList } = data;
  if (articleInfoList.length > 0) {
    const articleInfo = articleInfoList[0];
    const { largeImage = { url: '', height: 1, width: 1 } } = articleInfo;
    return {
      height: largeImage.height,
      width: largeImage.width,
      url: largeImage.url,
    };
  }
  return null;
};
